import { ActionCard } from '~/eds/src/components/Card/subcomponents/ActionCard';

export const IntegrationCard = ({
  integration,
  search,
}: {
  integration: any;
  search?: string;
}) => {
  return (
    <ActionCard
      actions={integration.actions}
      chips={integration.chips}
      hoverAction={integration.hoverAction}
      logo={integration.provider}
      title={integration.label}
      name={integration.name}
      description={integration.description}
      statusText={integration.statusText}
      search={search}
    />
  );
};
